import routeData from './routes.json';
import structuredData from './structuredData.json';

export const metadataBase = new URL('https://sterk-aanhetwerk.nl');
export const openGraphImage = new URL('/Photo1_me.png', metadataBase).toString();

export type SchemaName = keyof typeof structuredData;

export interface PageMetadata {
  title: string;
  description: string;
  alternates: {
    canonical: string;
  };
  openGraph: {
    title: string;
    description: string;
    url: string;
    type: 'website';
    locale: 'nl_NL';
    images: Array<{ url: string; alt: string }>;
  };
  twitter: {
    card: 'summary_large_image';
    title: string;
    description: string;
    images: string[];
  };
  h1: string;
  schemas: SchemaName[];
}

type RouteEntry = {
  title: string;
  description: string;
  canonical: string;
  h1: string;
  schemas?: SchemaName[];
};

const aliases: Record<string, string> = {
  '/diensten/individuele-coaching': '/loopbaancoaching',
  '/diensten/workshops': '/sollicitatietraining',
  '/diensten/lesgeven': '/lesgeven-public-speaking',
  '/diensten/zelfcoaching': '/zelfcoaching'
};

const entries = routeData as Record<string, RouteEntry>;

export const createPageMetadata = (pathname: string): PageMetadata => {
  const normalizedPath = pathname !== '/' ? pathname.replace(/\/+$/, '') : '/';
  const canonicalPath = aliases[normalizedPath] ?? normalizedPath;
  const entry = entries[canonicalPath] ?? entries['/'];
  const canonical = new URL(entry.canonical, metadataBase).toString();

  return {
    title: entry.title,
    description: entry.description,
    alternates: { canonical },
    openGraph: {
      title: entry.title,
      description: entry.description,
      url: canonical,
      type: 'website',
      locale: 'nl_NL',
      images: [{ url: openGraphImage, alt: 'Hanneke van Keulen, loopbaancoach' }]
    },
    twitter: {
      card: 'summary_large_image',
      title: entry.title,
      description: entry.description,
      images: [openGraphImage]
    },
    h1: entry.h1,
    schemas: entry.schemas ?? []
  };
};

export const publicPageMetadata = Object.fromEntries(
  Object.keys(entries).map((pathname) => [pathname, createPageMetadata(pathname)])
) as Record<string, PageMetadata>;

export const getStructuredData = (schema: SchemaName) => structuredData[schema];
export const professionalServiceSchema = structuredData.professionalService;
